import React from "react"
import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { AppOfficeGroupsAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeExcludeOffices() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useAutoEuropeDataInfo(d.filterGroupOffices ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterGroupOfficesExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupOfficesExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupOffices')

	return (
		<Box>
			<AppAntSwitch
				falseText="Include offices"
				trueText="Exclude offices"
				falseIcon="circle-check"
				trueIcon="ban"
				checked={isExclusion}
				onChange={e => updateMode(e.target.checked)}
				chipSx={{ mb: 1.5 }}
			/>
			<AppOfficeGroupsAutocomplete
				label={isExclusion ? 'Exclude Office Groups' : 'Include Office Groups'}
				placeholder={isExclusion ? 'No office groups excluded' : 'No office groups included'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupOffices', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}